import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { createQuestion, updateQuestion } from "../../api/QuestionApi";

function QuestionDialog({ data, onAdd, onUpdate, onCancel }) {
  const [item, setItem] = useState({ ...data }),
    [changes, setChanges] = useState({
      id: data.id,
    }),
    [isBusy, setIsBusy] = useState(false),
    handleClose = (_, reason) => {
      if (reason !== "backdropClick") {
        onCancel && onCancel();
      }
    },
    handleInputChange = (e) => {
      const key = e.target.name,
        value = e.target.value;

      updateItem(key, value);
    },
    handleSubmit = (e) => {
      e.preventDefault();

      setIsBusy(true);

      if (changes.id) {
        updateQuestion(changes)
          .then((question) => {
            onUpdate && onUpdate(question);
            setIsBusy(false);
          })
          .catch(() => {
            setIsBusy(false);
          });
      } else {
        createQuestion(changes)
          .then((question) => {
            onAdd && onAdd(question);
            setIsBusy(false);
          })
          .catch(() => {
            setIsBusy(false);
          });
      }
    },
    updateItem = (key, value) => {
      let change = {};

      change[key] = value;
      setItem({ ...item, ...change });
      setChanges({ ...changes, ...change });
    };

  return (
    <Dialog fullWidth={true} maxWidth="xs" onClose={handleClose} open={true}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          {changes.id ? "Edit Question" : "Add a Question"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="Question"
            maxRows={5}
            minRows={3}
            multiline
            name="description"
            onChange={handleInputChange}
            required
            sx={{ mt: 1 }}
            value={item.description}
          />
        </DialogContent>
        <DialogActions>
          <Button color="inherit" disabled={isBusy} onClick={handleClose}>
            Cancel
          </Button>
          <Button disabled={isBusy} type="submit" variant="contained">
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default QuestionDialog;
